module.exports = __webpack_public_path__ + "img/proxy-bookkeeping.76017d0a.svg";